var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMscheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_241_6651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.0002 25.876C51.0002 12.0689 39.8074 0.875977 26.0002 0.875977C12.1931 0.875977 1.00024 12.0689 1.00024 25.876C1.00024 39.6831 12.1931 50.876 26.0002 50.876C39.8074 50.876 51.0002 39.6831 51.0002 25.876Z",
    fill: "#00A88A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.882 14.0867C25.7622 14.0296 25.6317 14 25.4996 14C25.3674 14 25.2369 14.0296 25.1171 14.0867L11.523 20.5869C11.3629 20.6634 11.2281 20.7863 11.1353 20.9402C11.0424 21.0942 10.9955 21.2727 11.0003 21.4536C11.0052 21.6346 11.0615 21.8101 11.1624 21.9587C11.2633 22.1073 11.4044 22.2224 11.5683 22.2899L25.1624 27.8615C25.3788 27.9503 25.6203 27.9503 25.8367 27.8615L36.3749 23.5454V34.4285C35.8942 34.4285 35.4331 34.6241 35.0932 34.9724C34.7533 35.3207 34.5623 35.7931 34.5623 36.2856V40H40V36.2856C40 35.7931 39.809 35.3207 39.4691 34.9724C39.1292 34.6241 38.6682 34.4285 38.1874 34.4285V22.8006L39.4309 22.2899C39.5948 22.2224 39.7359 22.1073 39.8368 21.9587C39.9377 21.8101 39.994 21.6346 39.9988 21.4536C40.0036 21.2727 39.9567 21.0942 39.8639 20.9402C39.771 20.7863 39.6363 20.6634 39.4762 20.5869L25.882 14.0867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2347 27.0571C18.1124 27.0139 17.9819 26.9949 17.8514 27.0012C17.7208 27.0074 17.593 27.0388 17.4761 27.0934C17.3591 27.1479 17.2554 27.2245 17.1715 27.3183C17.0876 27.4121 17.0252 27.521 16.9884 27.6384L16.0384 30.6606C15.9719 30.8728 15.9923 31.1006 16.0955 31.2994C16.1988 31.4983 16.3776 31.654 16.597 31.7362L25.1466 34.9362C25.3734 35.0213 25.6266 35.0213 25.8534 34.9362L34.403 31.7362C34.6224 31.654 34.8012 31.4983 34.9045 31.2994C35.0077 31.1006 35.0281 30.8728 34.9616 30.6606L34.0116 27.6384C33.9748 27.521 33.9124 27.4121 33.8285 27.3183C33.7446 27.2245 33.6409 27.1479 33.5239 27.0934C33.407 27.0388 33.2792 27.0074 33.1487 27.0012C33.0181 26.9949 32.8876 27.0139 32.7653 27.0571L25.5 29.6064L18.2347 27.0571Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_241_6651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMscheme);
export default __webpack_public_path__ + "static/media/mscheme.3c3545950cb8b6927801a3ab16511efb.svg";
export { ForwardRef as ReactComponent };